module.exports = __webpack_public_path__ + "static/media/Info-Blue.32a5ea62.svg";